import detailDefault from '../../detailDefault';

/* eslint-disable-next-line camelcase */
export default class detailIF4IF_Licenses extends detailDefault {
    load(sAction, data) {
        this.setVisibleFields(sAction, data.prefix);
    }

    update(sAction, data) {
        // call immediately after detailView field is updated
        console.log(data);
        switch (data.field) {
            case 'auto_renewal_end_date':
                if (!data.value) {
                    return;
                }
                sAction.dsClear();
                sAction.dsAdd('set', data.prefix + '/fields/auto_renewal/value', '0');
                sAction.dsAdd('set', data.prefix + '/changes/fields/auto_renewal', '0');
                sAction.dsProcess();
                break;
            case 'elements':
            case 'iwb':
                this.setVisibleFields(sAction, data.prefix);
                break;
        }
    }

    setVisibleFields(sAction, prefix) {
        const elements = sAction.dataGet(`${prefix}/fields/elements/value`) == 1;
        const iwb = sAction.dataGet(`${prefix}/fields/iwb/value`) == 1;

        sAction.dsClear();
        sAction.dsAdd('set', `${prefix}/fields/elements_products/def/visible`, elements);
        sAction.dsAdd('set', `${prefix}/fields/actual_elements_version/def/visible`, elements);
        sAction.dsAdd('set', `${prefix}/fields/elements_license_key_c/def/visible`, elements);
        sAction.dsAdd('set', `${prefix}/fields/elements_license_end_date_c/def/visible`, elements);
        sAction.dsAdd('set', `${prefix}/fields/iwb_products/def/visible`, iwb);
        sAction.dsProcess();
    }
}
